<script>
import { required } from "vuelidate/lib/validators";
import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

import VueDropify from "vue-dropify";
import draggable from "vuedraggable";
import Swal from "sweetalert2";
import hotelService from "@/helpers/APIService/hotel.service";

export default {
  components: {
    VueDropify,
    draggable,
  },
  data() {
    return {
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      editable: true,
      isDragging: false,
      hotelDetail: {
        name: "",
        description: null,
        info_place_type: "hotel",
        is_active: true,
        image: null,
      },
      editId: "",
      imagePreView: [],
      imageToSubmit: [],
      submitted: false,
      is_btn_loading: false,
      isSaveAndAddNew: false,
      isImageUploading: false,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  validations: {
    hotelDetail: {
      name: {
        required,
      },
      description: {
        required,
      },
    },
  },
  mounted() {
    this.setIfEdit();
  },
  methods: {
    // Method is use for set data on edit
    setIfEdit() {
      this.imagePreView = [];
      if (this.currentProps.isEdit) {
        this.editId = this.currentProps.selectedInfoAndServices.id;
        setTimeout(() => {
          this.hotelDetail.description =
            this.currentProps.selectedInfoAndServices.description;
        }, 100);
        this.hotelDetail.name = this.currentProps.selectedInfoAndServices.name;
        this.imagePreView =
          this.currentProps.selectedInfoAndServices.hotel_info_place_image;
      }
    },
    // Method is use for submit data
    onSubmit() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        let data = {
          hotel: this.hotel.id,
        };
        delete this.hotelDetail.image;
        data = { ...data, ...this.hotelDetail };
        if (this.currentProps.isEdit == false) {
          hotelService
            .addInfoAndServices(data)
            .then(
              (hotelDetail) => {
                let hotel_info_place_image = [];
                if (this.imageToSubmit.length !== 0) {
                  this.imageToSubmit.map((image, index) => {
                    let infoServiceImage = new FormData();
                    infoServiceImage.append("hotel_info_place", hotelDetail.id);
                    infoServiceImage.append("image", image);
                    infoServiceImage.append("info_place_type", "hotel");
                    if (index == 0) {
                      infoServiceImage.append("is_thumbnail", true);
                    }
                    hotelService
                      .addImageToInfoAndServices(
                        hotelDetail.id,
                        infoServiceImage
                      )
                      .then((infoServicesImages) => {
                        hotel_info_place_image.push(infoServicesImages);
                      })
                      .catch((error) => {
                        errorHandler(error);
                      });
                  });
                }
                if (this.isSaveAndAddNew) {
                  this.$emit("saveAndAddNew", {
                    ...hotelDetail,
                    hotel_info_place_image,
                  });
                  this.hotelDetail = {
                    name: "",
                    description: "",
                  };
                  this.imageToSubmit = [];
                  this.imagePreView = [];
                } else {
                  this.$emit("submitted", {
                    ...hotelDetail,
                    hotel_info_place_image,
                  });
                }
                this.is_btn_loading = false;
                this.submitted = false;
              },
              (error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          hotelService
            .updateInfoAndServices(
              this.currentProps.selectedInfoAndServices.id,
              data
            )
            .then(
              (hotelDetail) => {
                this.$emit("submitted", hotelDetail);
                this.is_btn_loading = false;
                this.submitted = false;
              },
              (error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for save and add new hotelDetail continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is use for cancel to add new hotelDetail
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    // Method is use for maintained change image event
    changeInfoServicesImage(event) {
      const imgURL = event[0] == undefined ? null : event[0];
      if (imgURL !== null && this.currentProps.isEdit) {
        this.isImageUploading = true;
        let infoServiceImage = new FormData();
        if (this.imagePreView.length == 0) {
          infoServiceImage.append("is_thumbnail", true);
        }
        infoServiceImage.append("hotel_info_place", this.editId);
        infoServiceImage.append("image", imgURL);
        hotelService
          .addImageToInfoAndServices(this.editId, infoServiceImage)
          .then(
            (infoServicesImages) => {
              this.imagePreView.push(infoServicesImages);
              // this.$root.$emit("imageAdded", infoServicesImages);
              if (this.imagePreView.length == 1) {
                this.changeThumbnailImageStatus(infoServicesImages);
              }
              this.hotelDetail.image = null;
              this.isImageUploading = false;
              Middleware.notification("Successfully uploaded !!", "success");
              document.querySelector(".has-icon").click();
            },
            (error) => {
              this.isImageUploading = false;
              errorHandler(error);
            }
          );
      } else {
        if (imgURL !== null) {
          this.imageToSubmit.push(imgURL);
          let image = window.URL.createObjectURL(event[0]);
          this.imagePreView.push({
            image,
            id: this.imageToSubmit.length,
            is_thumbnail: false,
            priority_order: this.imageToSubmit.length,
          });
          this.hotelDetail.image = null;
          setTimeout(() => {
            document.querySelector(".has-icon").click();
          }, 500);
        }
      }
    },
    // Method is use for change hotel_info_place image
    onChoose: function (evt) {
      const imageData = new FormData();
      imageData.append("priority_order", evt.moved.newIndex + 1);
      hotelService
        .updateImageToInfoAndServices(
          evt.moved.element.hotel_info_place,
          evt.moved.element.id,
          imageData
        )
        .then(() => {
          Middleware.notification("Image positions changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for delete image
    deleteImage(image, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          hotelService
            .deleteImageToInfoAndServices(image.hotel_info_place, image.id)
            .then(
              () => {
                this.$root.$emit("removeImage", this.imagePreView[index]);
                this.imagePreView.splice(index, 1);
                if (this.imagePreView.length == 1) {
                  if (!this.imagePreView[0].is_thumbnail) {
                    let image = { ...this.imagePreView[0], is_thumbnail: true };
                    setTimeout(() => {
                      this.changeThumbnailImageStatus(image);
                    }, 1000);
                  }
                }
                Middleware.notification("Successfully deleted !!", "warning");
              },
              (error) => {
                errorHandler(error);
              }
            );
        }
      });
    },
    //Method is use for change image as thumbnail image
    changeThumbnailImageStatus(image) {
      hotelService
        .updateImageToInfoAndServices(image.hotel_info_place, image.id, {
          is_thumbnail: image.is_thumbnail,
        })
        .then(
          (response) => {
            this.$root.$emit("updateImageStatus", response);
            this.imagePreView = this.imagePreView.map((image) => {
              if (image.id !== response.id) {
                image = { ...image, is_thumbnail: false };
              } else {
                image = { ...image, is_thumbnail: true };
              }
              return image;
            });
            Middleware.notification(
              "Thumbnail image successfully set !!",
              "success"
            );
          },
          (error) => {
            errorHandler(error);
          }
        );
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>
          {{ this.currentProps.isEdit ? "Update" : "Add New" }} Info And
          Services
        </h4>
        <hr />
      </div>
      <div class="col-md-12">
        <b-form-group class="mb-3" label="Name" label-for="hotelDetail">
          <template slot="label">
            Name <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="hotelDetail"
            type="text"
            autocomplete="off"
            placeholder="Ex : hotelDetail Name"
            v-model="hotelDetail.name"
            :class="{
              'is-invalid': submitted && $v.hotelDetail.name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.hotelDetail.name.required">Name is required.</span>
          </div>
        </b-form-group>

        <!-- description -->
        <div class="mb-3">
          <label for="description">
            <span slot="label"
              >Description <span class="text-danger">*</span></span
            >
          </label>

          <tinymce
            id="tinyMce-editor"
            v-model="hotelDetail.description"
            :plugins="plugins"
            :toolbar="toolbar"
            :other_options="options"
            :class="{
              'is-invalid': submitted && $v.hotelDetail.description.$error,
            }"
          ></tinymce>

          <div
            v-if="submitted && $v.hotelDetail.description.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.hotelDetail.description.required"
              >Description is required.</span
            >
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <label for="Image">
          <span slot="label">Image</span>
        </label>
        <draggable
          class="row"
          v-model="imagePreView"
          v-bind="dragOptions"
          @change="onChoose"
        >
          <div
            class="col-md-3"
            v-for="(image, index) in imagePreView"
            :key="index"
          >
            <div class="d-flex align-items-start mb-3">
              <img
                class="rounded cursor-move common-upload-img-size object-fit"
                alt="hotel_info_image"
                :src="image.image"
                :id="image.id"
                data-holder-rendered="true"
              />
              <div class="ms-2" v-if="currentProps.isEdit">
                <div class="form-check">
                  <input
                    :disabled="imagePreView.length == 1 && image.is_thumbnail"
                    class="form-check-input"
                    type="checkbox"
                    :id="image.is_thumbnail"
                    v-model="image.is_thumbnail"
                    v-b-popover.hover="'Use as thumbnail image'"
                    @change="changeThumbnailImageStatus(image)"
                  />
                </div>
                <i
                  class="mdi mdi-trash-can fs-5 text-danger"
                  v-if="imagePreView.length !== 1"
                  slot="label"
                  @click="deleteImage(image, index)"
                ></i>
              </div>
            </div>
          </div>
          <div class="col-md-3" draggable="true" v-if="!isImageUploading">
            <div class="position-relative plus-icon">
              <VueDropify
                @upload="changeInfoServicesImage($event)"
                :src="hotelDetail.image"
                message="Drop image or click here to select"
                accept="image/png, image/svg, image/jpg, image/jpeg"
                height="150px"
                id="infoServices_images"
                class="mb-3"
              />
              <i class="bx bx-plus fs-1"></i>
            </div>
          </div>
          <div class="col-md-3 placeholder-glow" v-if="isImageUploading">
            <p
              class="placeholder placeholder-lg common-upload-img-size bg-secondary"
            ></p>
          </div>
        </draggable>
      </div>
      <hr />
      <div class="col-md-12">
        <b-button
          v-if="$route.path == '/hotel-directory'"
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelSubmit"
          >Cancel</b-button
        >
        <b-button
          v-if="this.currentProps.isEdit === false"
          class="float-end ms-2"
          variant="outline-primary"
          type="submit"
          @click="saveAndAddNew"
          :class="{
            disabled: isSaveAndAddNew === true && is_btn_loading,
          }"
        >
          <i
            v-if="isSaveAndAddNew === true && is_btn_loading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i
          >Save & Add</b-button
        >
        <b-button
          class="float-end"
          variant="outline-primary"
          type="submit"
          @click="onSubmit"
          :class="{
            disabled: isSaveAndAddNew === false && is_btn_loading,
          }"
        >
          <i
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            v-if="isSaveAndAddNew === false && is_btn_loading"
          ></i>
          {{ this.currentProps.isEdit ? "Update" : "Save" }}
        </b-button>
      </div>
    </div>
  </div>
</template>
